import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./styles/globals.css";
import LandingHome from "./routes/landing/Home.js";
import DashboardShell from "./routes/dashboard/Shell.js";
import LiffShell from "./routes/liff/Shell.js";
import OfficerShell from "./routes/officer/Shell.js";
import ClientShell from "./routes/client/Shell.js";
import LoginPage from "./routes/auth/LoginPage.js";
import PairPage from "./routes/pair/PairPage.js";
import EnrollFacePage from "./routes/enroll/EnrollFacePage.js";
import EnrollPasskeyPage from "./routes/enroll/EnrollPasskeyPage.js";
import ScanPage from "./routes/scan/ScanPage.js";
import ScanWizardPublicPage from "./routes/scan/ScanWizardPublicPage.js";
import OAuthGrantPage from "./routes/oauth/OAuthGrantPage.js";
import SessionExpiryWatcher from "./lib/SessionExpiryWatcher.js";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionExpiryWatcher />
      <Routes>
        <Route path="/" element={<LandingHome />} />

        {/* Unified login (SEN-634): the self-built email/password auth (register /
            forgot / reset / verify-email) has been retired. /login funnels to
            SENTRY Accounts; the old auth paths now redirect there so no stale
            self-registration surface remains reachable by direct URL. */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<Navigate to="/login" replace />} />
        <Route path="/reset-password" element={<Navigate to="/login" replace />} />
        <Route path="/verify-email" element={<Navigate to="/login" replace />} />

        {/* Public NTAG ↔ Location pairing landing (entered via SDM tap-back). */}
        <Route path="/pair" element={<PairPage />} />
        {/* Public officer face enrolment (entered via single-use admin-issued token). */}
        <Route path="/enroll-face" element={<EnrollFacePage />} />
        {/* Public officer passkey enrolment (WebAuthn ceremony). */}
        <Route path="/enroll-passkey" element={<EnrollPasskeyPage />} />
        {/* Public NTAG SDM tap-back landing — verifies CMAC + opens task wizard. */}
        <Route path="/scan" element={<ScanPage />} />
        {/* Public scan wizard (LIFF-free). Identity verify via WebAuthn / face. */}
        <Route path="/scan/wizard" element={<ScanWizardPublicPage />} />

        {/* MCP OAuth 2.1 consent page — Claude.ai redirects browser here
            after Custom Connector add. Requires dashboard session;
            auto-bounces to /login?return=... if not signed in. */}
        <Route path="/oauth/grant" element={<OAuthGrantPage />} />

        <Route path="/dashboard/*" element={<DashboardShell />} />
        <Route path="/liff/*" element={<LiffShell />} />
        <Route path="/officer/*" element={<OfficerShell />} />
        <Route path="/client/*" element={<ClientShell />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
